module.exports = __webpack_public_path__ + "static/media/qingming2Bg.3b788c14.jpg";